/*
    Where a folder lives in the address bar.

    Folders used to sit directly under the mailbox — /m/<account>/<folder> — and that put them in the
    same namespace as the screens beside them. A folder really called `contacts`, `calendar` or
    `settings` could not be opened at all: React Router matches a static segment before a parameter,
    so the URL went to the address book instead, and it did so quietly. The names are not exotic on a
    Turkish mail server either; `settings` was already in that position before contacts and calendar
    made it three.

    So folders get a segment of their own, `/f/`, and nothing else is ever added under it. The old
    shape still resolves — a URL somebody bookmarked keeps working — but nothing generates it any
    more.

    Both parts are encoded, which the old code did not do at all. An IMAP path is a mailbox name
    chosen by a person: it can hold spaces, `#`, `&` and Turkish characters, and any of those turned
    a working folder into a broken link or, worse, a link to a different folder.
*/

export function mailboxPath(accountId: string, mailboxId?: string, emailId?: string): string {
    const base = `/m/${encodeURIComponent(accountId)}`;
    if (!mailboxId) return base;
    const folder = `${base}/f/${encodeURIComponent(mailboxId)}`;
    return emailId ? `${folder}/${encodeURIComponent(emailId)}` : folder;
}

/** A screen that lives beside the mail rather than in it: contacts, calendar, settings. */
export function sectionPath(accountId: string, section: string): string {
    return `/m/${encodeURIComponent(accountId)}/${section}`;
}
